export default class Bestilling {
    constructor(element) {
      this.el = element
      this.subtract = this.el.querySelector(".subtract")
      this.add = this.el.querySelector(".add")
	  this.addButtons = this.el.querySelectorAll(".material-item")
      this.amount = this.el.querySelector(".amount")
      this.products = this.el.querySelectorAll('[data]')
      this.increaseValue = this.increaseValue.bind(this)
      this.decreaseValue = this.decreaseValue.bind(this)
	  this.searchorder = this.el.querySelector("#search-order")
      this.materialitems = this.el.querySelectorAll(".material-item")
      this.init()
    }
  
    init() {
     	
       
			//console.log(this.addButtons)
			this.addButtons.forEach((element, index) => {
			
			var addelement = element.querySelector(".add");
			var subtractelement = element.querySelector(".subtract");
			
			var amount = element.querySelector(".amount");
			
			addelement.addEventListener("click" , event => {
					this.increaseValue(amount);
			})
			
			subtractelement.addEventListener("click" , event => {
					this.decreaseValue(amount);
			})
		});
		
           
    
       
        if (this.subtract) {
        
            this.subtract.addEventListener("click", event => {
              this.decreaseValue()
            })
    
        }
		
		if(this.searchorder) {
			this.searchorder.addEventListener("keypress" , event => {
					
					var inputFromText = this.searchorder.value.toLowerCase().split(" ");
					
					this.materialitems.forEach((element, index) => {
						var datadef = element.getAttribute('data-attributes').toLowerCase();	
						var match = datadef.includes(this.searchorder.value.toLowerCase());
						
						if(match) {
							
							this.materialitems[index].classList.remove("hide")
						}
						else if(!match) {
							
							this.materialitems[index].classList.add("hide")
						}
						
						if(this.searchorder.value.length < 2) {
							this.materialitems[index].classList.remove("hide");
							//console.log("this.searchorder.value.length < 2: " + this.searchorder.value.length);
						}
					});
			});
			this.searchorder.addEventListener("keyup" , event => {
				if(!this.searchorder.value){
					this.materialitems.forEach((element, index) => {
					this.materialitems[index].classList.remove("hide")
					});
				}
			});
		}
		
		
		//events on addbasket button
		this.materialitems.forEach((element, index) => {
			var addbasket = element.querySelector(".addbasket");
			addbasket.addEventListener("click" , event => {
				
				var id = element.getAttribute('data-itmi');
				
				
			})
			
		});
		
		
		//this.searchorder.addEventListener("keypress" , event => {)};
		
		//addbasket
		
		
      //console.log('Example-component initiated with this element', this.el)
	  
	  
	  
    }
    increaseValue(amountInput) {
        let value = parseInt(amountInput.value, 10);
        value = isNaN(value) ? 0 : value;
        value++;
        amountInput.value = value;
        //console.log(value);
    }
    decreaseValue(amountInput) {
        let value = parseInt(amountInput.value, 10);
        value = isNaN(value) ? 0 : value;
        value < 1 ? value = 1 : '';
        value--;
        amountInput.value = value;
        //console.log(value)
    }
  }